import React from 'react';
import PropTypes from 'prop-types';
import styles from './SocialMediaHandle.module.css';

const platformIcons = {
  Twitter: '/twitter.svg',
  Instagram: '/instagram.svg',
  Telegram: '/telegram.svg',
  TikTok: '/tiktok.svg',
};

const SocialMediaHandle = ({ platform, handle }) => {
  const iconSrc = platformIcons[platform] || platformIcons.Twitter;

  return (
    <div className={styles.socialMediaHandle}>
      <div className={styles.bg}></div>
      <div className={styles.label}>
        <img src={iconSrc} alt={platform} className={styles.icon} />
        <span className={styles.handle}>{handle}</span>
      </div>
    </div>
  );
};

SocialMediaHandle.propTypes = {
  platform: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
};

export default SocialMediaHandle;